// src/utils/eventUtils.js
/**
 * Devuelve true si es un evento de velocidad (≤200 m), teniendo en cuenta vallas
 * por ejemplo: "100", "100H", "110H", "200", pero no "400", "1500", etc.
 */
export function isSpeedEvent(eventCode) {
    if (typeof eventCode !== 'string') return false;
    // quitamos sufijo H si lo hay
    const code = eventCode.replace(/H$/i, '');
    const meters = parseInt(code, 10);
    return !isNaN(meters) && meters > 0 && meters <= 200;
  }
  